import { createFileRoute } from '@tanstack/react-router'
import { Main } from '@/components/layout/main'
import { DepositAllocationLog } from '@/features/company-bank-accounts/components/deposit-allocation-log'

export const Route = createFileRoute('/_authenticated/deposit-allocations/')({
  component: () => (
    <Main>
      <DepositAllocationLog />
    </Main>
  ),
})
